import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.97.56Q1.66.7 1.6 1c-.01.07-.02 1.9-.01 7.05v6.96l.04.1q.08.2.29.3c.1.05.12.05.24.05s.15 0 .23-.04q.2-.1.3-.3l.04-.09v-4.87H14l.1-.05c.1-.05.2-.17.26-.27.07-.13.07-.34 0-.48-.01-.04-.68-.95-1.49-2.03L11.4 5.36q-.02-.02 1.45-1.98l1.51-2.03.05-.16c.04-.25-.09-.49-.32-.6l-.1-.06H2.06zm.77 4.8v3.66H7.7c3.98 0 4.98 0 4.97-.02l-1.26-1.68c-.69-.92-1.27-1.7-1.29-1.75-.05-.12-.06-.3-.01-.43q.04-.08 1.3-1.77l1.27-1.7H2.74z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconFlag;
